<template>
  <div class="thank"></div>
</template>
<script>
import Cookie from '@/common/utils/Cookie.js'
export default {
  name: 'AnswerPage',
  mounted () {
    this.checkLogin()
  },
  methods: {
    checkLogin () {
      if (!Cookie.get('Admin-Token')) {
        //  获取不到token => 未登录
        this.$mint.MessageBox.alert('请先登录！').then(_ => {
          window.location.href = window.location.pathname + '#/questions'
          document.title = '问卷登录'
        })
      }
    }
  }
}
</script>
<style scoped lang="stylus">
  .thank{
    position: fixed;
    top: 0;
    bottom: 0;
    width: 100%;
    background: url(../../assets/images/question/thank.jpg) no-repeat center center #08abc2;
    background-size: cover;
  }
</style>



// WEBPACK FOOTER //
// src/views/Questions/thank.vue